import { render, staticRenderFns } from "./RrpToggle.vue?vue&type=template&id=5a71eff7"
import script from "./RrpToggle.vue?vue&type=script&lang=js"
export * from "./RrpToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports